export default {
    'estimated_quotation': 'ORÇAMENTO ESTIMADO',
    urlBuses: '/',
}